// extracted by mini-css-extract-plugin
export default {"NewProjectSty":"newprojectStyle_NewProjectSty__MKRjg","NewProjectCardSty":"newprojectStyle_NewProjectCardSty__0zumc"};